/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Profile_Stats_AchievementsInputs */

const id_profile_stats_achievements = /** @type {(inputs: Profile_Stats_AchievementsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} pencapaian`)
};

const ms_profile_stats_achievements = /** @type {(inputs: Profile_Stats_AchievementsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} pencapaian`)
};

const da_profile_stats_achievements = /** @type {(inputs: Profile_Stats_AchievementsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} achievements`)
};

const de_profile_stats_achievements = /** @type {(inputs: Profile_Stats_AchievementsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} Errungenschaften`)
};

const en_us2_profile_stats_achievements = /** @type {(inputs: Profile_Stats_AchievementsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} achievements`)
};

const es_es2_profile_stats_achievements = /** @type {(inputs: Profile_Stats_AchievementsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} logros`)
};

const es_mx2_profile_stats_achievements = /** @type {(inputs: Profile_Stats_AchievementsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} logros`)
};

const fil_profile_stats_achievements = /** @type {(inputs: Profile_Stats_AchievementsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} achievement`)
};

const fr_profile_stats_achievements = /** @type {(inputs: Profile_Stats_AchievementsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} succès`)
};

const it_profile_stats_achievements = /** @type {(inputs: Profile_Stats_AchievementsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} risultati`)
};

const hu_profile_stats_achievements = /** @type {(inputs: Profile_Stats_AchievementsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} teljesítmény`)
};

const nl_profile_stats_achievements = /** @type {(inputs: Profile_Stats_AchievementsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} prestaties`)
};

const no_profile_stats_achievements = /** @type {(inputs: Profile_Stats_AchievementsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} prestasjoner`)
};

const pl_profile_stats_achievements = /** @type {(inputs: Profile_Stats_AchievementsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} osiągnięć`)
};

const pt_br2_profile_stats_achievements = /** @type {(inputs: Profile_Stats_AchievementsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Conquistas de ${i?.count}`)
};

const pt_profile_stats_achievements = /** @type {(inputs: Profile_Stats_AchievementsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} conquistas`)
};

const ro_profile_stats_achievements = /** @type {(inputs: Profile_Stats_AchievementsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} realizări`)
};

const fi_profile_stats_achievements = /** @type {(inputs: Profile_Stats_AchievementsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} saavutusta`)
};

const sv_profile_stats_achievements = /** @type {(inputs: Profile_Stats_AchievementsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} prestationer`)
};

const vi_profile_stats_achievements = /** @type {(inputs: Profile_Stats_AchievementsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} thành tích`)
};

const tr_profile_stats_achievements = /** @type {(inputs: Profile_Stats_AchievementsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} başarım`)
};

const cs_profile_stats_achievements = /** @type {(inputs: Profile_Stats_AchievementsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} úspěchů`)
};

const bg_profile_stats_achievements = /** @type {(inputs: Profile_Stats_AchievementsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} постижения`)
};

const ru_profile_stats_achievements = /** @type {(inputs: Profile_Stats_AchievementsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} достижений`)
};

const uk_profile_stats_achievements = /** @type {(inputs: Profile_Stats_AchievementsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} досягнень`)
};

const ar_profile_stats_achievements = /** @type {(inputs: Profile_Stats_AchievementsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} إنجاز`)
};

const hi_profile_stats_achievements = /** @type {(inputs: Profile_Stats_AchievementsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} उपलब्धियाँ`)
};

const th_profile_stats_achievements = /** @type {(inputs: Profile_Stats_AchievementsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} ความสำเร็จ`)
};

const ja_profile_stats_achievements = /** @type {(inputs: Profile_Stats_AchievementsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} 実績`)
};

const zh_cn2_profile_stats_achievements = /** @type {(inputs: Profile_Stats_AchievementsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} 项成就`)
};

const zh_hant1_profile_stats_achievements = /** @type {(inputs: Profile_Stats_AchievementsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} 項成就`)
};

const ko_profile_stats_achievements = /** @type {(inputs: Profile_Stats_AchievementsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`도전 과제 ${i?.count}개`)
};

/**
* | output |
* | --- |
* | "{count} achievements" |
*
* @param {Profile_Stats_AchievementsInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const profile_stats_achievements = /** @type {((inputs: Profile_Stats_AchievementsInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Stats_AchievementsInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_profile_stats_achievements(inputs)
	if (locale === "ms") return ms_profile_stats_achievements(inputs)
	if (locale === "da") return da_profile_stats_achievements(inputs)
	if (locale === "de") return de_profile_stats_achievements(inputs)
	if (locale === "en-US") return en_us2_profile_stats_achievements(inputs)
	if (locale === "es-ES") return es_es2_profile_stats_achievements(inputs)
	if (locale === "es-MX") return es_mx2_profile_stats_achievements(inputs)
	if (locale === "fil") return fil_profile_stats_achievements(inputs)
	if (locale === "fr") return fr_profile_stats_achievements(inputs)
	if (locale === "it") return it_profile_stats_achievements(inputs)
	if (locale === "hu") return hu_profile_stats_achievements(inputs)
	if (locale === "nl") return nl_profile_stats_achievements(inputs)
	if (locale === "no") return no_profile_stats_achievements(inputs)
	if (locale === "pl") return pl_profile_stats_achievements(inputs)
	if (locale === "pt-BR") return pt_br2_profile_stats_achievements(inputs)
	if (locale === "pt") return pt_profile_stats_achievements(inputs)
	if (locale === "ro") return ro_profile_stats_achievements(inputs)
	if (locale === "fi") return fi_profile_stats_achievements(inputs)
	if (locale === "sv") return sv_profile_stats_achievements(inputs)
	if (locale === "vi") return vi_profile_stats_achievements(inputs)
	if (locale === "tr") return tr_profile_stats_achievements(inputs)
	if (locale === "cs") return cs_profile_stats_achievements(inputs)
	if (locale === "bg") return bg_profile_stats_achievements(inputs)
	if (locale === "ru") return ru_profile_stats_achievements(inputs)
	if (locale === "uk") return uk_profile_stats_achievements(inputs)
	if (locale === "ar") return ar_profile_stats_achievements(inputs)
	if (locale === "hi") return hi_profile_stats_achievements(inputs)
	if (locale === "th") return th_profile_stats_achievements(inputs)
	if (locale === "ja") return ja_profile_stats_achievements(inputs)
	if (locale === "zh-CN") return zh_cn2_profile_stats_achievements(inputs)
	if (locale === "zh-Hant") return zh_hant1_profile_stats_achievements(inputs)
	return ko_profile_stats_achievements(inputs)
});
export { profile_stats_achievements as "profile.stats.achievements" }